module.exports = "select, textarea {\n  width: 100%; }\n\n.nationalitySelect :nth-child(-n+6) {\n  background-color: #d9d9d9; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notifications/createnotification.component.scss
// module id = 580
// module chunks = 1